const SIZES = {
  xs: "h-7",
  sm: "h-9",
  md: "h-12",
  lg: "h-16 sm:h-20",
  xl: "h-24 sm:h-28",
};

export function BubzLogo({ size = "md", className = "", onClick, testid = "bubz-logo" }) {
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={testid}
      className={`inline-flex items-center select-none ${onClick ? "transition-transform hover:scale-105 active:scale-95" : ""} ${className}`}
    >
      <img src="/bubz-logo.png" alt="Bubz+" className={`${SIZES[size] || SIZES.md} w-auto object-contain drop-shadow-sm`} />
    </Tag>
  );
}

export default BubzLogo;
